import axios from 'axios';

const API_BASE_URL = 'https://takeawaybackend.onrender.com/api'; // Replace with your backend URL
// const API_BASE_URL = 'http://localhost:8080/api'; // Replace with your backend URL


// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 seconds timeout
});

// Function to handle logout
const handleLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Dispatch custom event to notify components
  window.dispatchEvent(new CustomEvent('logout'));
  
  // Redirect to home or login page
  window.location.href = '/';
};

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle network errors (backend down)
    if (!error.response) {
      console.error('Network error - Backend might be down');
      handleLogout();
      return Promise.reject(error);
    }

    // Handle 401 (Unauthorized) - token expired or invalid
    if (error.response.status === 401) {
      console.error('Token expired or invalid');
      handleLogout();
      return Promise.reject(error);
    }

    // Handle 403 (Forbidden) - insufficient permissions
    if (error.response.status === 403) {
      console.error('Access denied');
      // You might want to redirect to a different page instead of logout
      // handleLogout();
    }

    return Promise.reject(error);
  }
);

export default api;


export const validateToken = async () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return false;
  }

  try {
    // Make a request to verify token validity
    const response = await api.get('/auth/verify-token'); // You need to create this endpoint
    return response.status === 200;
  } catch (error) {
    console.error('Token validation failed:', error);
    return false;
  }
};

export const BASE_URL = 'https://takeawaybackend.onrender.com/api';
// export const BASE_URL = 'http://localhost:8080/api';